<template>
    <div class="area-404">
        <!-- Generator: Adobe Illustrator 19.1.0, SVG Export Plug-In  -->
        <svg version="1.1"
             xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"
             x="0px" y="0px" width="206.5px"  viewBox="0 0 326.5 592" style="enable-background:new 0 0 326.5 592;"
             xml:space="preserve">
            <g id="shadow_1_"><image style="overflow:visible;" width="192" height="103" xlink:href="data:image/png;base64,iVBORw0KGgoA
            AAANSUhEUgAAAMAAAABnCAYAAABWxU1RAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccll
            PAAALnZJREFUeNrsfdmSHMeRbSyZtQBdBBdrzR0ZJBu7ZpqHmUf+AH8C/8P/wU/wB+6j9CCajck0tDsatVEk2A10VS7h48fdIzKyqroBQtNY
            qAygLXKrLfMc38LDw7mlLW1pS1va0pa2tKUtbWlLW9rSlra0pS1taUtb2tKWtrSlLW1pS1va0pa2tKUtbWlLW9rSlra0pS1taUtb2tKWtrSl
            Le0jan65BR/NvaXlli4EWO7TQpzlwX7A9+A17/X1G77N1+8S1LQ8/OW3vsVrzoH093r9s+nIs7/zSz8/e+Df6S2IQws5/nEI4N/+mq9/NqCv
            rq7Ovtf19fXR8S/f8Ov/v9nebre7E4iXl5d0L2nKTibN138P2GkhwMf3O+4B+hzgz+4B9H1g3u9/mJ/7N+0ONzdy/Hdv+aO+tX59caHA+8P
            pNZvNZ3SOOHeRJhPm+VmCfP02oKeFAB/O9z5z/Jk/Ft/PzoB8AviXZ0F9+O1N2a8BfXt7O7/ucOD9p7Nv0HX7t7rPq9XmBFzr9dXJse12S2d
            J84dzZLmbJCDHGxKDfilk8L8s0M+l+jHQaym+3/9fP4GWwf27CdwTqP+Fz73094G57xnw/2faH7uOz1/yPzt31Iahv/eeN017AqK2XdOVbcf
            Vi+n8X6bz9xGnJg3IUkjy5ws6R45jYnyTzaznP4sQtBDgYb6jPyvhGe1fnQX7l0WaZyn+tJLah8OlPwZ2/4UCd+yeSH8M5hrEsv2ZgX+4KMc
            /PbpuHAfe/uSNf3SMr6gmxY/1OSHJD/L/mDT19kScKybOikCYTJaaJJkg35kmmRPjP+iYFHNCyAZ9rGTwHwnwT6X8kYTPgM+SPUv1DPZjoAP
            kkNaQ1RncGbAK6s8Y0Lpfg7kGsmzv8jHnkvUiacdNBf5Rty+mX1FfixZiM4HkJpMg0kSIhm7sRH1tfKXbsRz7qWzXxInNDYEwOJZJkgmStUr
            7/USO9foxb//phBR3EuLNyEALAd4a+M/8OSl/DvAAew109J+zNAfQC8h36D9zO97HsQzicXx0BOqN35ZzDOSLCbzJQL5Jtp+Sfrcttld2bJx
            IUV9zRwsh0O1sX0kg/e1tuUbIHhToQYjyUs/dZkLo627jnjJhhBjXql0ySW6YDKJRfvihkKMmxpwUV/QnEItJcRch3pAMtBDgjYA/SXsA/0T
            Ks0lzDvA12GtpfmFAHx89KoB/hH0GMsCdtjj2mIHN2wzqRwDsOvljMK8TjvH2ZlMAjX0q261f4ymvJrDrdesJAUdE8AZqM8wKyMu5Pf+20FN
            9bSFHh/29O/B+OD536OTYKznWEMgSbg+FJJkgIAS0CcgBElyblmiubwop/lZpikwI0RDfwoyaCHFKhg+XCP7DBL7a9V99NZk3d4H+BPC7Cz+
            BnYH+aBCwF6BvGdy8DekNyZ0BDgADpOtV6+egXvl2VYM78Xbr1YTg1xDx9koATTRds8LTbRtfg12vfX0L3s+A7v1AXTdJfu+tDwPh2gPO+Wj
            H+kICvL7vIvkAEhg5mEgHu0aPdbQ/YBvk2FPbrRPI8Iq3a1JkTXFMiEwGfN5/MSGa71g7MBlqzfAhE8F/DMCHeTM8vfX/fA70n/T+cLsOGfD
            deh8A8K2BfeiacAz0duhDWun2CscM4OMQwwTs1mdQNw36RvYVxK3T41SIIeeNAMTXN/m6cp7KuXtvypBBXpOgdwP2ewW/EqCXawTk8jre9iN
            lAslxJk4Y9HrsB99T30fdZhLUBGFQp9D1dOBjTTOmwKTYz0ixZ1IoIVarLikhmAzXajZdP96nuzRD1gofIhH8h2TqnAC/kvYvX74I4+dP/Kc
            M+v32VUDEBaDv1qsACb9moGfAr4YupPUKGiFAoqPPknwcGBEswWODXkEbo24D3NREAa+Cn88zYGMa+XwsQMY1ET3hGgZ20+hxysDHddFTzNt
            8vJCgKWQ4uTEZ9AzkoZb0I44Pcn4o1zCox5GEBLw9mKbwAnhvvgEMuWDHBgE8Xu+HUTTHwOczQWIcE8gRGfyeTaoBJGAN0QxjqknRtUMCIbL
            ptDpsEjTE7eZRgnbYbi9SrRmOtcIdRHhvJPAfgtR/9kyjOWeBv3sRIO1vb2/CYauSHqDvu32AlO9Xh7DqmzC0/FcBvmFpPjLIxzGEtm1h9rD
            5y08Skp4fLaQ34zrUAE9xxCNXYMcIDRGEDAZmBbyBX/aDZzQzfEACPLrglQgk1wjYKxLo46VKIzQ5mFrA7yqA1+AfBejewD3yf+YotuVYKtf
            qdaNK/VG3+Vclee2ox1Pgm8AaQwgyQBvwPt+KcUwM5shEGGD+pJoUw9Am9CBED23BvkXXrFKzGtKKCQGTaXXo0u16myITYcOE+LH9iTbXuwQ
            iXH16k+A45/GGiQhlXOG9kMC/P/Dzj37GUr8GPps6T5+eB/72cBsAfEj6GvQwZ4aGkd25mAHfMNJZKwQcFjkWRn7E3DPAAfoUIdvYnGFDWMB
            vYOdHzcdSALAF5PW2XeOMEAHAJiOBSNtpX8HNJBBO5P0K/C5rgJgDpXZTjknAoE2J7KwRQME+jtW+ESNlTQHACxnGcg1+GMgBEYBzyXqAHwQ
            JCS9nk2nkOwLNMDYJBMmkQI99NiNHJQSTgYnQSz+mrmcydEPqVn1qWSvATIJW2NweChF2uy/Sd9v/JiWCagMZfX6PJPAfDPhZ6l/+eBFg4+9
            2mzABvw2w65tbH4dVw6C+je3QKOgDg35A3wHHDDXHxowHzhnkQwgDC3ecxiMOXkgQjAyJ97FBuWeAE95EegV+MAIAwHlbQM5WNgVIeUYlCVq
            9C6oJlBCqBYDvYPszPyATIsY8UHBkAhkRHKQ8A3zMxxTMKZ9nheTZtca5kb8ZyCIk8vh4SjVp+CelTATRANAESe5I0tNQDMH6TAp+w+j4hik
            BYoNIcGLAs7Jgggy807ZuBBnatB57JsKKFQ7MpM34eDxAO0Ar3DIRNocEP+Hx9ZMkPgKbRU+e/IZJ8UcjQTGJ3ikJ/PsA/zMGf23yXF5ehSz
            1dy83Yc/AX738KULiA/grBn4XGS4s5ftwYEh7+RNw947FsY8MgBiGaRuMkGMAO3rdkGMkREiq+ANwKwcE+CAGgM1QCQC152sE0NAXzkycYKa
            PM8AH9Cx4FXl8zglB4I4Gk/wi9UPWAtHVmqBIfkU6uWTHINUV6fzx2Hcq6flNlCj8FnBcuE9yvV4n1wh3lDT8XRLIIr8QV/CLkgFfjEKQg3t
            sQXvwb0AUwMAfpGfcJ74vI7ZZIzIB8F40ggzQCik5pgRvr3AtH+9ZS6zTKEQ4sGZ4ROOatQF8hOvr/cws4uefSh7S83dLgndJgBPwv3jxqwC
            T5/p6F3a7a5b6W5H6Kzazm1sXD+gN+AB851IDqc8PsKlBz8+4gfRnFR/9yOd5G6Bn+5d5gNfyq3GMHy96ATxkOgQ74AsUeyUCjGRARkIpIv4
            hQnnfBZXwALZohYSXAqcKbmgMIYoziR9E0gcRw9nk8aYB3B1OcH7YBnASAhjYSTUAVWA3kkDyQyv4igSyj5cnoVzCe+NL8y1AOAzfLOk+uMK
            3gl2AkDUBsfEPcjDYQQb+5FGIQrrfOD/IdqQRpAD4CccY+OihFVhLDiACNMKwYS3BPRzmrnNjrQ1OSPCONYF/l+CvzZ45+Dfh+vqHuGXw3zY
            hIsiCsEzsfDy4VeMr4COQ6H2jPe8D9LI94LgCH+M3hQTJRQG7betxCD5vYGckONYl2BdJDpLwFgHBsDxMA0CuChEEimbyBAE/iCJXZtvejkO
            MeyOD2f96PriTSJA3yV8euJg5SZSJqgrdhxbQY+poOAM+BLaaPNASGIpAL986Cd65x2tEpzHwhQB4URBNwT3catIeUp/VkZBCQK9/mRAIumK
            fd6UH6PnTBvTyR4P0q3UYlByBrSQ3rkEG9uehDR73abybBCc+wYMRoHlnLvCRzf/06dUE/ga5WjG+9DAzoWQ3DQHcDZubrmtcCm0GPt//lm8
            H94ShyibgOhcRkefzIIURwIEwMIl4n71W8UmxDRIwJxwEHX+WhxgH2PFPrBpSyW7awMAfnEh2J+YNDByFlzq7QG85p9aLHCDBYuUE63sYdsM
            8SQZyPdv2AnmSSBBsHKMNlX/eCAIqKkfMPHKyby/mDkDm/wEch68QkvgGXi4Z+SskXOOCWFXcsw3GbjCG7rxsOwx9j2Kb8VNh+gHYDHw/MI8
            GfsEgsVeXBn4NvO/e9wOfiz05xjzv8e3Ea8LWdYPIEL4H/KjdS/4wNnfd9e6Fu/zxibv67U26/uu/8sf9EVhBoh2ZwKj7j0oDzKT/V199E2q
            bfwb+l4xg7l+xGRn8KJKd/7fUDgz22K54hzHM277l59QyhLUnJQZLxhbpXl628WcawKnExz4kOt971QCiFdTk8YIKXGegFlNZ7X/RBiQAD6Q
            ngxrnALDAVcBuYRvxC3wmQ7bxSR/66f32R/eeTlQ+kYJ78hFU3ai5g2sU6NksUuUgdhhsH32dSHsv5o/4A2LyiP1kmgA+gUh2OMbSs7ZVqc/
            HRQMEIYFIe5H+Ang/8E3rHbYZ+Ax3Bj57ZD7xX+zZIJJtORaant+arwUZuiFhCNvFoRuPNMHVTXry5K9JQqTfION0Nk5AH6MG8Fn6uyvN4UG
            05/Djpd/tQIJbkfz75hMWyQp+AD+1fbsKrk0DY78Z24HBz7bmilXySiT/6FYM4ZbFOhPBM/jxx6TBduTflBz7Y0HBj9EsfiL8zFn6E5PCB9U
            SYs1Hl+1/GPkiliVqE5xGb4IqCJg+glhv13m1Q/TYhGYRu97rruGexFC3m1GB/nhEuIBckK3Xq90/MURozD/F9I1phUQm/cu+EkE/JJhGEOk
            vx/QPhAjai1aAxBefWyR/6UPZH7yAX3vsM8kA6t6PqY8hMuCpZ6ei45dCG0fEY0fYiaMDzfgugyMr/kad/PpaE+y7PcEkvrpCyst/OPcVkol
            m5s+DaAH/8NL/mYzwZrv/8vIiINqzfRFj2waYPWzGbAv4Vwx+yVCIrCmTZ9C7FUvsFYvsVRppzRp6FVnyEwjhmQhMggDNEKjlB9Moqalh9cz
            vpyaRBiRZypMMS4kmMCDHyQGW3isxIN3N3hcSZBPHNIQjM3e8Ob0G7mICqXHuHJnXmzWFOQDurpwgs/Nd5k1WC3rcmz+g4Fb14LNpZE4ymZa
            wsQRSsx+UkS04w0kJhpE5GVRArGjMvgGIQDLMpuAnMYPU7pcROzZ1lARBAM/vBinf8Yt7freOdWSXrGcnuOPHcmCN0g2MemiFEHGONcJhYPM
            oslZpBjjGu50bDwc3wh948lcNj1Za4MF8gebhpb9zWfoPbPd3141HqPPlNrABOarNnwD+oYV0z+BnZbxODH6++Wt+MGtKcc0PZBW4x3E2X1f
            8CSsQISHphv9AABZzbSYBIkUggTN/gMTOFzJoL2CWSKVIf5PowYs9IZrCT1EgdXLNJBLg6yCAxnlcFe2RQKTL1MiWf9YC9yXEKZLtVaYF1B/
            ImoCKSSSmj3kUvjoGS0dGx3RkTl+Hc0nNJvEahBSUSQBzCE4CxpKVgZMGcBhi8Gb+YJTN9aoBEvqeL2Z7P3V8zzrkRsizZAGD++tF22K8jb0
            C9gBYx4NK8L/lRiLyjO8mqRS3iW6fjPT09td0JROYrhk7JbX6wXwB/9DS37H0//KM9A/hgtXk0NCmbwlmz+BX7AesQIAQGPyege/SJvm4FhK
            MtOE7t/Y4ntyaFPxrFtvwB1ivevUHxCQyAiCoDS0gkaIUndrwUQwJRW4wkRyMFACrmTga2THb3xcn2JnpQ24CuB2bAO6PbH5zev00Gnx0r6h
            yDcwRTrVZVAbGxGIpPsAkGX1+hZtMIRuBmPsCbh4NEo1Aol7EFBI/QKwoZF8oETT3wg0B0p+Ql6fA5+tZ+vuO3501gEN/4DdmiZ8OfHv22Oa
            33rNKPbBQO7D6PYyJz0fWCIPr2CVg/6Dv+RH38Ac+de2AMYIXvxrGd6UFHjwKBFPu6oz0j27PCraN285HRHv4RjZ821s2Uti0aUTys6/K0j9
            tGDwbls8bFtFrFlMbflhrfoRMBjWD+GavxAwi1gIBEp81AcyhpKFRifZAKsEg1m0Fv4I8mN1uDq6QoUR2guUZOPUDDGuFEGXfRJOcUDJQZfJ
            781lrgUPnfQAiV95i/sD1DST4lDVENpnU9FEZaX5DOW+EMGcZEVNnYwKk15oGUIeYz8PsgZ8tESE+Z5EgktAmv5Ztf4IfgNzUjkT7EgIUDYS
            L81nD4p4kIX5C/Bl0QyCpkaE6nMBgDOggJFyFPt32h9B/IVrAQwuwWfTgI8EPSwAzf9D+hf/97Yv/75sX0W8Toi+PGNJd6AYf257vT9AwZsP
            2/UDjCtEymD6MWTZ9QALPwOc+ce9owzdtrSYQ8XXsK3hik0icYo0CsQYgDIyJ7a9+gC+mj6CraAAJg05hTttWYCcyg6cg0h9J/0naC8wpR4C
            8Pw33HIGesu9MNBNs2bipCOBzZMhI4Cq2ZJD7iTiZD7XPYH6BRoOc+AXmC6i/kWwkYlRfAOAn8Q8kAsRECJkExGYPTCHvkDnYIBXQw5QVoSL
            DymJHqnwhM7dGxGP5IHvMLo7s043I3+rbyL7GgY3VdRg3Tfq8cx6FCJAXJhOgxAzCmMDX/mPyAWbTFg+/3frDj2xguid+2MEDHVi+HIIb2tA
            2iIkR3w/cQAxwYXQd0tyvGKor/slrlkT8x+ZQ8Bu+0UIGTK8SEwj+gRcfANe2DF91hJNJJFekkkR+nM9mj5o44vRqZMgbiH0FbG8ife7sZoe
            WSoBTNUAV369sfX90W/zpXfLu3KinP1H5PqsRopnbMGmCjH4doqZsUqk2KNdKPCgZYZJdnwTw0kNCQwOYP+Bd5QSzKeQRZXN2f2UgMvqcBiK
            3ImFQgWScgV0AGXPwiAUha7thsrA3EOIwNpGfP/thB3YHxj1yrUJPMXUdaZWOv37JFvQf/Tfu9w8WDWoeCvgS/cHAl+0hye1TGOwsG0YGf0o
            tW/oxDB37QIEJIANWiPeH1sKZGPCSaA8LDkywYnMIcwpVAyTsO8/gD5ivyGYQrsn2P5tTrgyKyUCYjugC6BRJcR3s+wZf2fdGDl9Fa2xgy/b
            J+eLP+vKj/YmpMwM3+Tf0ve6uqDCZNzNVQj5HTT3N1UyJBLkSJTLfgeZhUyOCE/BrL1oiiQ+QtUKJ/ogWiCrxMVtHQ8XIuQgmBtTRxkygwCY
            /3kNHimFG6ZQG9omRChi6yL5AiPwUab/hb/hKZuP1/eif3nbvxAx6cB9ARn1vQYSdZr4PPf9I/rGbHlMXETcIo2/4RiaTJgraoANakOg2AGZ
            Snk0dmEesMVaiJdhXEJIwt/j+t4gCeRsIMzKwpCdzfHW019BsMX1vUovCFMMvoBXnNogSqEdzZ6A+dWr9WQH+cwMOdLo7mUb+rFPoqVhKZvf
            47HmUsGoeJbZBNpgnZiaRDk7A6rNeyKEDYholQ/g4mpkYNMLqzGKS4WWV+F6iRQx69g28zGOzoISPkk6HoXhMx8Es5RajaCz6t6MPzSf8KTf
            qcnf/4vJEfzGln39sBKjsfzRMX2yaKFk5CbOr0spmdCTcFQYlMK8AZSgicQ1hyshWYzQbs9EbqTdTBsDkBuNPJL86Y6wFyFIhnMb5Vfp7s1G
            LlJdQZShSXh3YaXCLCtQ9OXc32OsRrCNzh05s/mMb6A7E+1OpN9n988GyU0f51G+Y/AA3jR2YWWS2E5k/IREi8w9GHTDzfroH2bGnvGkDa2L
            mtNIjJYI0XJpMG8uzwwg8EiqCVzMUbMCzlrnY8DBYKLKCGf2FR8yjLkj2gPg/Skh5yFaqp30i9XFkbm4abZZVU6YXpjBqejJvSaKahi3NhHE
            aX7ZjEtK0mLOAXVRzHtHNr7NBMLXzjQi4NsXsCJOjWN5bt4OFQy08SvNwqUaEgn1WjhCFybnWa3weV8h/3nyKO/7l87PXTKPN0+eXz5k+o/5
            eJ3+q8WJx+CHNfQn9mo8EGY5tX+6fJ1c0srO0kiJY/HQ+Pw/9jTZpWTStvGfQDFqSSUSYXNSQzsKT8fDU+q3bSCWOUprGKnwga2AqcPb1R0q
            Af5s26/o70jZ1JoxOM3Q2pTDn2Vto3PJvNMOSLL+GdPZJdkqzyWJAoOLAzmL1NE9XyJJ/stv9cWx/svknKe8tVGPXzJLhqmuOw57ZSXzd38l
            Ywfz9aHLUzbv1tSab/dHseyjVyE1Svdwj8jn6lX/3lNpNNslHwsiqPYls4E/9Ih08l2eig4Ahp4m7kjU7Pdt5wYC6dtJ4UjryyweF58MT4A/
            3OQhH+4OhPU/1G7ONMc2QmtIAnEVDNCO5sjEyLsncUZrlmlWjplWcUa+jmSFy18CLmReVSeLPXkOncf4qLn/vn7/LGT7+zOq7+FMziE6+m40
            JzCKsU8oFzb+zr28GlbCrhVwF/1RFbisLrp7Ukwfo/OSUq1F8FhLxTG3Uj9oJLu0vqCjWsrfzitLN2oVtpAOy1pxWMygA0el8iMfJTCZ4x2R
            pvDqjSaIVMjgjgzQ6oJN0SrhX50yjFiblbJAqR0DEbCAzhjWkY3F9TW+YaYMiPWkmfX0JwFMlkalkgE4vrs+/3UCmr2lJE8DoTBoplQt0rKy
            QhIoTbJeR/dyUQZ3HApzlC7k8OmxpEToq7EcLi8pIsQyqUX4OXhPq4DQnSX0bZUC55Bh5maRf0rZNN+ATpKCXJKyTzX/WhjkCu8s/klZn/cg
            JoEVZB2V55F8qRZkO3G3SoBm3cvNl2JBvVcwTMfyUjZhj0aQjkYOz0d3svFpuvmXPTPo72+vmPySx+/V1SS2gKgJkZHBlZPfIrPHzwS2apTv
            44/jnXfGfnxMGrQNLdBwRckUTzqS9ymZfpUj4aVBsli6h+4nMCTZyjFTCoUFBLwlxLifE9fosMBqM0KgmyeWJMrovyXRDkHkHXmeNhaSkGvG
            +TRpTT02LnBRPqhG0cl5EbSE3lXt8/oA+wMMR4LnmQaAMxnZ7Q9fXWphVS3awG3Q4UGzb1Pc9xeBSwGC5TwJ6JzOPFPAM0Z5Q+4kk0U0T3Fz
            gV8h9K4OyFpgkCSvllN9qBJjEWZMpe0HnNEpkyOzkPCg25fcbZo7zempiTOAvYwP+rkxP/3PjoHQvKfyxeUN+HhmapVCXhDifeaJAzy6Eppp
            6HQvwNhbgLTVa+TNoajSDPCEdgoGP8Ca5jnukQ3R82zoQg+VKJ1miQPTI1wZ9bSiTa5gQEc8BZGhQliWh9oy7JalO59MN9U9eIA7qHlLyPxQ
            BJlNB6sh/41ED5lv3K3fJrG7Z7/mR8RzdHikkDPE+rVoMB7SsOqWEsmQeskzBTF/JOHReskc6mc1lERlNZrSES68DO05HMXGDW0zBy6E3b1E
            OGwCbIjsWBSG1kcIU+vR+8o2qsKibRn99cQBykhv5efTxLil/J0FOc4JOcU9nAqp1LlBlAim484jwLJnO5XRoZ+dVWNjgWNKJMVIjzMYASFO
            jddrj6DQJDpNgMtAPSIZjyXPgaw7BKSn4XTtJ/Mf1KfSquVVb6DxjTKb3UmIl9imF1Zo/8xWToKX2+4bcrpsL04/MBMKcTv/N5TNCJqhUEv7
            EOVQM276IKYSLlNIhuW3LEsCnppVizCjuN3iMhmNCBaZkxyDpC4k0bq+5B8Gmm7s8y0mH6kkTtZCnTjIeIGHNJof/YC4ZGSQFmnIKRAG8mkI
            5UqPAl3RpN0VcNC1u0gZ5hGlm9/h53k/OoSNPZ4T56bh+PaqQyZBm5JhNmKE8GuymqZPZUc3xNWVosfdz6oOZTskXIlAeDR7Ndx3FBGLNbPH
            9UaS/mjwdcoL4Mw8irj3AT3t+wwO/FNV9UYGXiUBKCE9dZIGGmWD8jWRSPcDfDZTGdsPqYM+qoaVP+Q/zmb/bDvRE6ovuPmInmJm7+2pH+73
            zKJH3xfc7ajaI8KAC8aOU+kOidSMFm6kNkPyYZIE08Thq6QUBZnA6CcoQoxO+Nb13lNETj2QtSH4MgqXGYzKMaQAZFDPgS3Icv6dMkFcTKOT
            kN7KYuo4LuJL3P4U8c4h+Motoiluekfx+TgR/3geg14z+epvwe3aAy6IxibLDO80gU4lONg8gk8BPA15Tn6aMUFf1frRip4NmhKqAUXPI95I
            SjUkwIv0d4hldcmHvA4OfewIZnN/z3RWtwPs9q/W+cWNPKM6IChJskq5WrGH2zAdiEqSb9Lcnr+hz92ta/5l/z+avthjH8werEPFOnGBUATt
            89ytaXaoZxP5AinFIfscSBZal64ZVx7cuakWGEblSCBpkx1RHhFC3KqfzIoNRctNJHLHED8LmA9i8AJK5ASFK/UEthSIT4M0sKmkRNqBTzKB
            pZliZHzDF+auYP9mwMk2EmOf+O7pjnYM3qRBdT4+ko1SHkvSWp8PQLOHNIj7m7Jd5AToRXjNA9Vyd/0NTHpAmruk8YckHkoDDmIMPTus46lw
            Ap7PB+Cvw0/MHfinmOrL0h43rD1FIEPaM9UMEUfi6vok9351htaahH2gYUj+m1ZAQMnrcq/nzp92f3GO2/6XM+vOHAf5DEqDyA54Tm0FOzKD
            1hVQNvr7epc3G+5/8mJqObT/XjFvkyVr1ABYToYnwCNQ+QVDISnuIY0aobcXAT5h8TZKSiyS4TtMgRPJrBQnexqhlsqQ4GXnXKFCwKZKBbEa
            YRoRQCkUrzWp6tBbe9FXJk1ozeM0b0BDqlBpXzKJaK9AsOe4kO/Tc8y1RT+9nDu1EjjLhpUR1jo7liS9m7pBNjiEFvEaBJTyp0TdvER9zfqm
            YQYhR65TIoNuw46GpWWxjPgBmhim4PSa+sLnDD/PAd5oJEQ4GfpkQg7nDbOT2LNqYSCsmwTDSS7H9pTjX9ZMxPU5PqPluoM2Thzd/HloDKBH
            MDMJE5+9YC1yyFviRtcDF7WoMoWMkDTbhhOHeswvQsvfLt79BupBUQxsSy54k8yowvTqlQep8sxoOkpcOR6vkAsmEeB90Yjy0QMjVIcjHsq1
            1f2L2BfK0yEyEnBznpxHfYBOCfS6VYkOlflYlYrJaLOOAcuqmDxOKX0uADPrk6xOGfxtc0nENyrMw8xisDc8KiGsnN0eDksbwVUNMyW9kEp9
            sfnCZByBOcCjhZznWk4WkRQM4zAbzYgp5mRXGz4O1QTNSxwq7Y/V7GCMf5/0hUhfGtvd4fqz1xxRG2qLM6SfjbnBp+H5P/7W7osfrS9rtbo8
            rQzyIFngHJtBcC4gvwFpgu8NcAXaEouUmCxlWqJwhAZ8xDVLNp6GYtADmKNXFImrBJTi7CfHTDqVRWAq1jGa+55gXzC9Js2xQzXUhy2REDlD
            SqZE6RZIku9Ekfy6BYmMLeS6wVouwLOJgEXafC1xNk+bJyOyr+QB64VQbyN8xKObrka2qRmiqsjhshKNKZzaproNZxQeQag9yjc37LdEfraK
            o5k6QijCkYWMvocqkINeZYeL06uT4aU6wlDZJMi2SkN+fQs83i8HOJEhOI0MjaQTIs45nqY/zfWTp3zc9hY7fo2Xw8xlR9CiNckh/e7ynz3e
            /TvurTdqcOr8fXWGseVGjSgvAF9g9/SJdX3/vYAq9bMO4ehURFXYo8ey7lQopzPhFnT6oZ8K9iiNbP6g0hjnAPRNB5w3AxMG8AVhOXmsCYZQ
            FyW4wg0jqgzotizJNjglBE+K415IoTmc0+VIehTQqZAZ9jvSEEhHyzurSZp9AxxSO5grbGJxaMyHcXRbxOAVhmt8b3DTOldOcRbjbpBc/SXc
            Z7iDb18nvNpprg12a/x9sHjBpjUQd+U0S4RHgB6sSASdVpH+y8igWysw9ibSinpgEEEiI4LHhxGapRHv6yGY+SykpmxLgMDd8LYM/OfZ6XRy
            2bPr3/aCmz/WT9N2n/01PNr+hM3WBPiof4E4t8JVs/yZ9t/3PcHm4oOvHLxJqwrx8FBxIIAmyWMiBn+lhwHRfVDEeUVoPlb2tJAcmVLg+Yeq
            jrFUE0EeN+pASIFhZRA2nessatcxQylmlk/SXMYHSqxOMzAubS+D1WiksqglhvtQC8kYUXyeaGe39lBZBMgCRj997q6zmT7CRvGkWWHFo6zw
            gI4KFM608ok2GUQI4X2L8WfJbaFQkP1IWpJSimD8JnleuETSKyUk2I0xGcrM/EAYWWTo9EiRg6Y6xG9UKKJTFkp79WxTIis3Adm3sYfOr2QP
            Jn8Gfxpvtbfrk+rKUR0Tqg65mj3Gk5w8q/X/u4OTf8/6zwrhXV5chl0PPFaFZE0SUQs8V4lAUV4rgoi4oA7cTgMdWjvUIcTZy3Fk1uNHsfWe
            TYbQCXMR7lGK5QeqAWo1QSdLV2qAkBY89Soh6TcXWOkHzeqAIz1ZZjZI2bJWgbZL8uTqgpPHW+ZzHe7SAP0qsS47qpDMb4Ep5NFgK4EptUCu
            Si0J3UlI9aXHcXBWurhFaaoOW4rheyiLmfRTHLZXhvNTZkm2KsoCT1QaV0VzRBo04x8FSIQbtxVTSSnAbFMq1IrkYB7g9dOmRgR/rBny/u06
            Pry5TWUHmHdQDetcEuJ8EL19ImcT9fh222zbcNtdSILfZM/CjFyLEoEVwexBiQJ0sP6sSXRfHVQJopWgMNkq+OgCL4gRAcYJDnErOel0VWnu
            W/pkMkjWBnDyrDm1VJObVoHU+7FQJ+rgKNIn542wxjSrE6WcZlLM7h1LNU0i0rhxNlDMyq4rRRgRxhiU8BUkO7ILziUo5xCTBX4mqoUa8Rte
            0GK4mG8pSIlIdOleFBtiDlUbHAFZjZRIlX7fxQxQyMNiT9rkgbov9TRzY3hk3o5P1AlD+BGXSb5+MI8we+IQz8MuqMb+c6tBnSDAtiVST4Hh
            hjNUrH9frJuzjy4gZ1KgU3QXMI2W92msPiS8EGJxGeFBEHStmSKl0JUFIvqwPgBlJWBGAZF2Aan0AWxdAioSTXCF1QWdrAnhgmKwytLdkAx0
            rsLUAtPJPXgvAh9lqMKGqB6QLalSjxNn2SfMU5LwQxpR5ofU+7TiZMpA+5crQkOJWJj1o9tlUF9QqQcv1lFIulitao1orAFWgZfEMgByLR6F
            cuvQ0pmqNAABdCNHo8bxOAIA/rlASXStCA/gwefKKMcdVoefgf3eVod8VAe4lwfX1v/oXL/4z1EsjySIZog1eBV0kgz2q1SE0hxCHNmK1F1s
            ZRhfL0IVdQhiECEPEgBpWhwkCez4JTSBrYnjAXvq8MkwSQoxBiXG8MowunAFQw2aIQYONUmf3eEUYK5deVocRWW1GmWqHs4Nglot0NuEt5XS
            I0Qq0WGSoXgxjtmqMLYJRVosRc2gyjcpKMfilWC9MpICIfFslJu/jPyxILJAhnGDwt6OsrQNqGOixSowsjLEiWSVmxdtYPwzAx3JJwxZrAui
            6YZD6N9sLNnn2Z5dKeh/gf5cEuNccumuZpF5WhGQi7JkI3SpAI3RMBKwECR8Bi+G1bByBDE3TB2iG2fpgWAsMjw09P93R9xGL4MkqMCkvlTT
            K4jGy6J0sFSfDYzLhW5dOygvhxWrGWvDn1gQLeT2w2VpgUaqNxiqFbU4AdTTO3C3JP1aQj7P1w4QEKa8HMK0TlsajbVsKCcu5CP3LWmGJQrV
            UUr0kEhYCwyqS0QB+bp2wcWhSBn3Dhk69NBJWkNSlkTYM/D7lVWGQBzY3eT4jVH7DT1Kb//2sE/aeV4n8erZuAKa/1dpgRgTTCHkt4LxYHha
            8XrUdS/8oZDheIRKE0KVQmQB8IK8UqaSYrw6ZbME8OV6tDBnLtgI+lumb81UhZZ2xk9Ug4cycLojhzi2VekQEWftr0GVT6/N5idTZypEAd1k
            l0tYNs1UigyyaN0pNkmmRPKwUGbByfBpkcTwF+zBIJQIDfiOVzAF4ydpksA/VSpFNPySsJQxpv1r1DPyNrAmGNYSPgZ/XDj6V+holPJvx+o4
            B+Z5IgHZmqdRqxci8ODZMI8wrzsul1mS4b41gLIY9soaApsAi2OM4kSIvfp2389rAmLgty6jKusCostWWtYAV6NO6wDVZ8GtiBX7pIx1FgcI
            9UaA0J8F4vHaw+eF2To7bMZlrMep2WS518LY+sIK8rBc8DAz0WJZH1cW0FexYbT42Teo79FhAuyMB/Jm1glsGfXz1itZs5lw3N7S5fZTyKvJ
            3Af99S/33TYA7SIAb8fuzRECVsKe3/8THvhdtkBfMBhmG3YWHifS6VeKhIdYA+9HC2XmF+BbrwrUwg5qzq8MDzChZp75oVcniaFX40xXhlTj
            NjADpHgKEAoChjAbr/Nl6FfkM6nr1+HOLYYurHTHxZKAMchzXFeN7mEYEyd6FDpqCMthl+4AV5Fdpj0Wxb7FCvK4HfG61+OMFsu8H/vuV+h8
            CAX4WEWAa7fc/CBkG1gr/XGmFseuYDJ8YGVBsS1eQByHGR4NUoXgEQnCfTaZMisQkQEWCTAxUJUtSn133BfxSuWAt4M4kkSqMSYsr4/wK5bk
            k585NlQ6OtIBxAZl75dy5BnDKVJC+JoWaQBnQALlcIhWlwmQWVeDW6xTguD50SMQxkMt+T1gBXvf5OEt2mDPBVoCPt2z48fYrbBvgMaPvmv+
            wIjy2s6Q/Br37lu/Y+sMG/odCgNcSAVWR4CPgSNYK2IbDPNwqGbCfCYHFtfusHVBi47PP3M6256RAD2IwqLdIcHwstWmEHAD+elVKdmB/jdj
            KZuNSVcpDwb5x0CQz8FsvA9VHDSQSFtzVGP29j6eFsTDPR3I4wkSCPV+LRV15wxuY8zWHri/kOAa5agWV6pifHRnkkOxivgngX8kxlfBzwK8
            Y8H/B7yigf0yI6NSgx/u8IfDfK/g/JALcQwT1EbS7gwzFTJp8BpGQTAjn/sl9DnIckQL1Zy5KnaJPXCaGANjMKGyPo4IbJEl2jF1F/ygDfYt
            +dVLfZp0mM2c6vpl1Z9t+vpFBLb8zTOZRAfuhK6CfwK0TyjPAM7DnIMe1P8l2luzO/eBgzkiOzJGEx7EMeOf+5LJ5Iz9n8xlh6msBfXFui43
            /wQH/QyXAXd/rtWQQyJwhBAqzo8zenBSoPqZ+hNjaVowJJpRzSo5Pq+OFJOh3eV+Jgj6TpRDmwoBfFwGT9tiOj3ebQDED/uXRcQbsjW7XoL6
            xg3LejmFxFay6Uva53Vi9HdjsjHMBeGPHAPQrd4WlOmdgFyKzWYP+PsDfA/oPFvgfOgHegAjnyXCOENlkQq+kAEkm00ntaSaDlW8EOS7zsey
            QZpKIBsHWZ7MqZhfVdibMfP/tWgawtp9m+zdVESkBNiT39XRsDnA0BTlqNGmZmlOgZ7Bnk0YBPzdr0KaV3T8+0H9MBHjdd62Omc9whhA1KbJ
            DXWsKNHS3R+QoZrmR5JQonc+lOz6tyHJMmnPt3Lnmnqpox+cmUFfARqvAXQP8GORbBvm32KiAXoP9GPA6N9dVFRqevwnI6WME1cf6nY+OV4Q
            wUkjB6jOaIhNDtcYPJ1ojE8RVJCnX3EOWu1p/hiw1sF/3+hrU54Cdt7/N5/98Mbs+mzDngH4e7CcS/j5w0y8BTL+U33Dm3FxTVN2MHKcEOU8
            SaVYA+HCjhPnda77wMYnqVgP4uH1bg/7CQP2HY2DndjfAswlTMD6ru3MW7K8DNv0SwfNL/U13nM8PfU6Oo82zRLlPo9wZ7Dkm0QmAz7X7QV0
            DuxgqJxv/TvPf+1Zgpn8UsPwj/s57rj0GzevJ4t6QPPeB+Cyg7wT2Xd/1rcFLCzCW3/6/QJb/jfb1QwKVFhAs7Zd8b2h5pAsBfmn3cgH10pa
            2tKUtbWlLW9rSlra0pS1taUtb2tKWtrSlLW1pS1va0pa2tKUtbWlLW9rSlra0pS1taUtb2tKWtrSlLW1pS1va0pb2j9T+R4ABAOgiAP26ckJ
            4AAAAAElFTkSuQmCC" transform="matrix(1 0 0 1 66.2048 489)"></image></g>

            <g id="robot_1_"><path class="st0" d="M152.7,89.2h-0.1v21.4h19.6V89.8c6.8-3.4,11.4-10.4,
            11.4-18.5c0-11.5-9.2-20.8-20.6-20.8c-11.4,0-20.6,9.3-20.6,20.8C142.4,79,146.6,85.6,152.7,89.2z"/>
                <path class="st0" d="M162.2,466c23.3,0,43.1-14.9,50.6-35.8H111.5C119.1,451.1,138.9,466,162.2,466z"/>

                <g><path class="st0" d="M159.1,356c1,0.9,2.4,1.3,4.2,1.3c1.8,0,3.2-0.6,4.5-1.9c1.2-1.2,1.8-2.7,
                1.8-4.4v-21.4l-12.5,22.4C157.4,353.8,158.1,355.1,159.1,356z"/>
                    <polygon class="st0" points="213.7,338.4 213.7,314.8 194.8,338.4"/>
                    <path class="st0" d="M163.3,313.3c-1.7,0-3.2,0.6-4.5,1.8s-1.9,2.7-1.9,4.4V341l12.5-22.5C168.6,315,166.6,313.3,163.3,313.3z"/>
                    <path class="st0" d="M283.5,262.5v-42.8c0,0-4.2-78-68.6-102.3c-19.1-7.2-36.6-10.1-51.7-10.7c-15.1,
                    0.5-32.6,3.5-51.7,10.7C47.2,141.7,43,219.7,43,219.7v42.8l0,65.7v20.6c-0.1,1.7-0.3,3.3-0.3,5c0,1.8,
                    0.1,3.6,0.3,5.4v0.5h0c2.7,34.3,29.3,61.7,63,65.4l0,0.5h57.3h57.3l0-0.5c33.7-3.7,60.3-31.2,
                    63-65.4h0v-0.5c0.1-1.8,0.3-3.6,0.3-5.4c0-1.7-0.1-3.4-0.3-5v-20.6L283.5,262.5zM131.8,
                    344.8h-6.3v18.9h-12.6v-18.9H87.6v-6.3l25.2-31.5h12.6v31.5h6.3V344.8z M182.2,351.1c0,3.4-1.2,
                    6.4-3.7,8.9s-5.4,3.7-8.9,3.7H157c-3.4,0-6.4-1.2-8.9-3.7c-2.5-2.5-3.7-5.4-3.7-8.9v-31.6c0-3.4,
                    1.2-6.4,3.7-8.9c2.5-2.5,5.4-3.7,8.9-3.7h12.6c3.4,0,6.4,1.2,8.9,3.7s3.7,5.4,3.7,8.9V351.1z M232.6,
                    344.8h-6.3v18.9h-12.6v-18.9h-25.2v-6.3l25.2-31.5h12.6v31.5h6.3V344.8z M231,242.4c-7.7,2.5-24,1.2-31.4,
                    0c-6.8-1.2-65.8-1.2-72.6,0c-7.4,1.2-23.7,2.5-31.4,0c0,0-22.2-1.9-22.2-30.5c0,0,0-31.7,22.2-51c21.5-18.7,
                    53.9-22.8,66.6-23v0c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.6,0v0c12.7,0.2,
                    45,4.3,66.6,23c22.2,19.3,22.2,51,22.2,51C253.2,240.6,231,242.4,231,242.4z"/>
                    <polygon class="st0" points="112.9,338.4 112.9,314.8 94,338.4"/></g>

                <g id="light_1_"><image style="overflow:visible;opacity:0.83;" width="142" height="143" xlink:href="data:image/png;base64,iVBORw0KG
                goAAAANSUhEUgAAAI4AAACPCAYAAAAsoeOtAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlY
                WR5ccllPAAADKhJREFUeNrsnQuP66oOhU2m//8fTzi6umdLPWxsr2VMQlqQqj4mk+bxdfkBGJHddtttt91222233Xbbbbfddtttt9122
                +1jW9mX4L+t1tq9JqWUuq/Ol4KjQZF2Mb8IrrIh2SB9PTgrwPItIJUNy4boa8C5AJZ2/3VD9FBwkmHJPu/6bRCVLwDmrnOsnwxQ+UBgy
                gX/U6+CaFWAyocAUxY615oN0YrwlIdDU5LObabi1CyIVgKoPBCYEVhmn2+dDdEq8JQHQRMBZqYJqwPbPB6g8oHAlETwMpWjZgN0Jzzlo
                dAgwJRJ8LA3uw4AtKz6lEWhQYEpifCMghOBpmYBdDU85SHQWEBkwDQDHOb9iCrdAk/5EGBGwMrycaJgpAJ0FTyrgMPc3EKCVJKhQW9q9
                PUj4CkPgKYE4IlCZH2OmCgGCubvjD90CTzlRmi8Xz8KBwoOa74YtUEhqMHtQ+ozE57yIGgQeNDnEXgYaNhnRp1uhee1QO6oEL4M8jwTn
                tps8/7+z2vrWcD9a/sVYl/P83EItfGgabdFgZkBz6jSaK+17VBlukV1yiLQsOrCvtY+ywBnBBoUpuXgeS2gbig01uvIdkykxaqMZV4QU
                4OavXZfl5mxcpHalAtg6b1nwGGdY0ZhtM+sbVAlQpzndNUpF0ATNUsoGNbnHjgFNFeMmbKgQP4eMWOXw/O6WNVGoEEgyYQnojgoNJWMs
                jzzFTGH94NDmKhRaEYeGfBkQHM6P7I6AA90rzJU5zURGtTPyYLmSASIAYdRmfPf42RVyMrraOBNVZ2ZpooNvSPQHEF4ZoDDQnOyv1EDD
                spkZajO6yK1QbLCEgTmcMA5bgDndJzed4hGAQqZrFUVh8kOZwLDADULnPPtJp5OhDQKkAbNdNW5KwGo+RpCQoM+M/B44TgDTfv6fPv/F
                prDgKcq1/K2fqwwOGAkhfY9eX6OB432WoMIgcdTnN5Dg8bKvbxD04OnGiCjWeR01VmldxzN1ViwePAgjjOqOB44LTSlA5Ao0LTwlKDDv
                J7iJKoN49d40KAw9fbdU0DtRtXG3GjgnG/77AHU3vx3aFCIiwHQVKBeN6uNgDCh0CAQWWbLOsaemToaJ/gdnBaYovgw59sxta/b4+mNB
                xqCJGquXpOg8Do1I10J7Y3vPX5ANfIUpzjQtGpTFHAsYBCAeo4wY7ammS4anIECAYjaCJDgs4BBFchTHURxDsO5ZfarAWSZ+gp0WRQlG
                lu2kzNbbY7A4weEh/FzejmY2sBSHWCKk5Npz7vdr6c8IX8mYq5ek2DJUJsCwvQDvPbg8fwcz78pitoIoBZ/9mUpTw8aRHWmmavZznFEb
                RD1KYbKMPD0ANIill63QSWhEQOa6vxYWNWZChEFTmByXZbaoNFUFB7EH6kdxTlJaKxhGQcAD6o6083VK1lVED9HSLVBssY/BjysydJuu
                OffoObOcrQ99YkMr5hirq7uqyri91mhuZwD8HUsiNjIqqc2lfhfMfwkVHG0AV2Xm6tZeRzPRKEZZa/TEoXnx8j1tPv1FCeiNlZ3xaEoj
                6c6yFCKad0PMDjBkX4F8GuyFEeDR1MdrSvC801QtUH7t94d7ApeCwSepfM4hTRRUTPlDdTqwfNjvPecZE8tCmmm0IcGkAZFUZzlUPaYc
                ZDv6B0XR9KZHM4RAAh1kDUA3sfWjABzKudWgYChGooioKoMqc8VIwA9aEamvxxgqO75OQdoqtpM7qncNGSw12GoDnItbi1CcFXmOBqme
                8lANs9jqY5mdmonkjmNbd9v4iH6gPVT+EH1nsm6zEF+TVYaZKBURG0OiQ25aFXHiqw05/gUvce7jb6ODjRWFwXblxcJu6/LHE9aWAyp8
                zc6v8obn+MlAXuRkQdNL8xGe9CRgf2WoniDvpZIAGYsC+TNOIiMDiyi90dZTjUKzil/d0pWxWc5jePuQSTCzcBIN0NoZHVXVDUabaGAH
                aAp00xVm6ltlcPrZ7LGE7Nz5WWCgxwG77UYGNFoK2rWrPyQdJziQ/FV2hzMSR6nCD7Pfon2ulldmAFPo8nDIv7Mh0P5rjZSQnMwSN0eA
                aCaqh6rgDNa8p7NOHt+EyP9At4wdL/ecbKKUu4G5v3Xc5cfE4GrAOpjOeFo+M/8DwIKAhITUIwGKI8EZzaMyJhnb1tGGTLL/zMgzVw68
                qPAYaQ9sk0ZuOEoWLKacnwDOFb9O29bZn/VSO5J4DvZNSA2ODdA5d24Cm4bXYwjXDqfBKhK3krEjwnH0RH66K+6AlAg5WKtSKUS+0DKz
                tYAKEsp1etCMLwprNqvqgKgMKPtWLOH7DMCCnsMURV7DDijYCAXKFKDrzcQ64+59ip9iuhl2k7Ry7cxhbBFYiVtbwHodQMs2uh87yKK8
                MWme0MbirFde4ztsZ0OLGfz2UlCHXX0v0px2IvkmQV0iGav3l7bjWB9fw+a01AiBCDkR4GY75Gg4v/O3QVjjlmfRTMDUSC0cS69DsgWI
                pF+1Sx0zPE7LKfyGas6qDm73b+BwfkfhRMGc0XMFVtPuDfEs+35fp/LhIw5rgo4GkSsLxTNR0X8xmVMlVUxSkSf/1yDSsMOyRTxp5v0C
                hqJ4RD/AvCcilrVATWKrte5VH0cTT0KAFYx8i0C+C4MNJr5KYDiVMURPjsA/SpARRzmUcf5UWtyekm+dnR+RHUsgFBotCm31g1qAfhV4
                DlBJToV3whxmr8uj+OF5ZFJbKdwZdmsyf4WOJqD/EvCg5bz95xmLeqcmvd5TVQW1M9hlQWBqfd9Gpin4BPyquMg/zqmKgqTZ6KGFrdnQ
                3EKHCKy8ipHaYtYoNB4c5FEiZ40NStNAhBxjlHV+RXOfLF5HxGs9z3drL0mmB9UjbRJ85bK9OZtM+XTLLVh54KfgOp4vg8TqjPQTPd/r
                vRxKmCukChKg0cAM2OpTQEUR3OQregKcZxZeGaE6ZeDEw27pUnvV8eHseDxoGHUBnGOe10NLDw1AE3vWFLM1NRytYCfg+ZzNICsGyTyd
                5l7Ebzmnqc2aDUtMczMGVCbaH7Hi6bWX8yVcJTFyNoikZa1mAYDjac2hVAcFp5fp2uC7exko6lHZY4zVMdaSbcEoDkFr6zuDd0YUZ6aE
                J5fFk3NVBzLv0FVR4Rf9LSC3QSHE00xq8ecgL+Dmip2Xc+0bPIlq8eQPeUjaxBEV85lhmAgIX0F913BLoVIMlACavPIPM6o6vTCXxFu4
                VNv9Tpm+m8lVKdKrI8qmtdBZ248No+Dqk77vrdSrrfwaa9eTW/1uqMBhll2yFMezQFGgGEGeqFqk2amwuAY5korGV9A1bEuRFtfRlv4t
                Fe3RlMaK39TjBuCglMBeCoJj5YikCyYVlQcKxlomS2vOJEFzeGYKLQIALrmuPccTf6h5mnt5aMTVccr7qyZLg0iDRqkfg0S3iN5HRSiq
                E+DAOPC9JQF672VTzwz9t6D3VsxtyRAw647jsLjAYOG36J8/6VqMxMcJMJifR4RbLioNPv31kjIBseatBedOqN1L9Q71GYYnMDsBw2aD
                IC0wkfI4mHZ4CDJvNGxx9HpzMs7xxYcmsliy5K10CBFp2UiOEKAk+kIM73kw2qTAk5wZKDmOKPwVPm74KOIX3gaKd6IguMpjwTgEeBzF
                JSpypM2yc6Axyt1htTLGy1NmwFNBjyRwVkieKWNeoXaXBVVIWYKVR6vhEoWNAXMakdNF6suKdAsqTiE6owojwheARSpBJqlOFEFEsHN0
                jA0WWqTDk4QnhkQSQAcxsdhwWFUSQagmW6i7k4AspnmSuzb2l/ETDHmSgDViJqjMDTLmypAdbxfuKcGEUVC1W0UnCg8SCZ4CJpstZkGz
                oC/EzFhkggNA84oPKyqLAPNXeAgN6wkgpQBTQY8WaBQI/seB84keFiQGCeYjapQp3kElKFZC7OgmQ4OAA9juhAICgFgpqkSUCWif6cd4
                ZnQXAJOEjwsFCUIJhsljkA0RWWugGYlcNBffwSOEZWRCerD+C9LQnMZOBcCNKIwIz5OxLSkAnMlNJeDMwhPFiRXgTMK07LQ3AIOAQ97k
                0dN0ig4UXiGgLkDmtvASYInU1EyfJwMRVoemNvBuQAg9PyyoqoMuB4BzRLgkPCMKsfs850F0zLALAVOEKBM81OSAckAaVlolgMnCM8VZ
                ikTKPrmrwTMsuAkABQ5r1mKE4ZlZWiWBicJoDvPceiGrwrMY8BJBGjmeeeN5V0cmMeBMxEi69pc0+/zEFgeD84NEG1YPg2cJ0H0dFg+F
                pzVQPokUL4KnKtB+mRQvhqcEbi+CYrddtttt91222233Xbbbbfddtttt9122+3L2z8CDAAGA9CHeMiJOgAAAABJ
                RU5ErkJggg==" transform="matrix(1 0 0 1 92.2048 0)"></image>

                    <g><circle class="st0" cx="163.1" cy="71.5" r="19.5"/></g></g>

                <ellipse id="rightEye_1_" class="st0" cx="215.5" cy="206.9" rx="11.2" ry="16"/>
                <ellipse id="leftEye_1_" class="st0" cx="108.7" cy="206.9" rx="11.2" ry="16"/>
                <circle class="st0" cx="42.8" cy="294.2" r="32.4"/>
                <circle class="st0" cx="283.8" cy="294.2" r="32.4"/>
                <path id="leftArm_1_" class="st0" d="M32.8,388.4v-95.1c0-5-4-9-9-9H19c-5,0-9,4-9,9v95.1c-6,3.8-10,
                10.5-10,18.1c0,11.8,9.6,21.4,21.4,21.4s21.4-9.6,21.4-21.4C42.8,398.8,38.8,392.2,32.8,388.4z"/>
                <path id="rightArm_1_" class="st0" d="M316.6,388.4v-95.1c0-5-4-9-9-9h-4.8c-5,0-9,4-9,9v95.1c-6,
                3.8-10,10.5-10,18.1c0,11.8,9.6,21.4,21.4,21.4s21.4-9.6,21.4-21.4C326.5,398.8,322.6,392.2,316.6,388.4z"/>
            </g>
        </svg>

        <az-call-to-action id="botaoVoltar"
                           @click="irParaInicio"
                           css-class="action-primary area-404__botao">
            Voltar para Início
        </az-call-to-action>
    </div>
</template>

<script>
    export default {
        name: 'PaginaNaoEncontrada',
        methods: {
            irParaInicio() {
                this.$router.push({name: 'Inicial'})
            }
        }
    }
</script>

<style scoped lang="stylus">
    .area-404
        width 100%
        margin 20px auto
        text-align center

        &__botao
            padding 10px 15px
            border 1px solid var(--v-primary-base)
            background-color var(--v-primary-base) !important
            color #fff !important
            box-sizing border-box
            margin-right 0
            margin-top 10px

        svg
            display block
            margin 0 auto
            overflow visible !important

    #robot_1_
        animation-name verticalAnimation
        animation-duration 1s
        animation-iteration-count infinite
        animation-direction alternate
        animation-timing-function ease-in-out

    #light_1_
        animation-name blinkLight
        animation-duration .5s
        animation-iteration-count infinite
        animation-direction alternate
        animation-timing-function steps(2)

    #leftEye_1_, #rightEye_1_
        animation-name blinkEye
        animation-duration 1.8s
        animation-iteration-count infinite
        animation-direction alternate
        animation-timing-function linear
        transform-origin 50% 50%

    #leftArm_1_
        animation-name moveLeftArm
        animation-duration 1s
        animation-iteration-count infinite
        animation-direction alternate
        animation-timing-function ease-in-out
        transform-origin 50% 10%
        transition all

    #rightArm_1_
        animation-name moveRightArm
        animation-duration 1s
        animation-iteration-count infinite
        animation-direction alternate
        animation-timing-function ease-in-out
        transform-origin 50% 10%

    #shadow_1_
        animation-name shadowAnimation
        animation-duration 1s
        animation-iteration-count infinite
        animation-direction alternate
        animation-timing-function ease-in-out
        transform-origin 50%

        image
            height 70px

    .st0
        fill var(--v-primary-base)

    >>>
        .v-btn__content
            color white

    @keyframes wave
        0%
            transform rotate(120deg)
        100%
            transform rotate(170deg)

    @keyframes moveLeftArm
        0%
            transform rotate(0)
        100%
            transform rotate(4deg)

    @keyframes moveRightArm
        0%
            transform rotate(0)
        100%
            transform rotate(-4deg)

    @keyframes shadowAnimation
        0%
            transform scale(1)
            opacity .4
        100%
            transform scale(1.15)
            opacity .6

    @keyframes verticalAnimation
        0%
            transform translateY(-10px)
        100%
            transform translateY(10px)

    @keyframes blinkLight
        0%
            opacity 0
        100%
            opacity 1

    @keyframes blinkEye
        0%
            transform scaleY(0)
        4%
            transform scaleY(1)

    @media (max-width 720px)
        .area-404
            width 100%

            svg
                width 30%
</style>
